export let WIXMP_SOCKET_MESSAGES;
(function (WIXMP_SOCKET_MESSAGES) {
  WIXMP_SOCKET_MESSAGES["FILE_STATUS_UPDATE"] = "status_update";
  WIXMP_SOCKET_MESSAGES["MEDIA_UPDATE_NOTIFICATION"] = "media-update-notification";
  WIXMP_SOCKET_MESSAGES["VIDEO_AUTOGENERATED_TRAILER_UPDATE"] = "VIDEO_AUTOGENERATED_TRAILER_UPDATE";
})(WIXMP_SOCKET_MESSAGES || (WIXMP_SOCKET_MESSAGES = {}));
//# sourceMappingURL=wixmp-socket-messages.js.map